/* Kickson motion system — modular, reduced-motion aware, GPU-friendly.
   No large dependencies. IntersectionObserver + CSS transitions only. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Brand intro (plays once per session) --------------------------- */
  function initBrandIntro() {
    var el = document.getElementById('BrandIntro');
    if (!el) return;
    var played = sessionStorage.getItem('kickson-intro-played');
    if (played || reduceMotion) {
      el.classList.add('is-hidden');
      el.remove();
      return;
    }
    sessionStorage.setItem('kickson-intro-played', '1');
    window.setTimeout(function () {
      el.classList.add('is-hidden');
      window.setTimeout(function () { el.remove(); }, 650);
    }, 1400);
  }

  /* ---- Scroll reveal ---------------------------------------------------- */
  function initReveal() {
    var targets = document.querySelectorAll('[data-reveal], [data-reveal-item], [data-house-tier]');
    if (!targets.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (t, i) {
      t.style.setProperty('--stagger', i % 6);
      observer.observe(t);
    });
  }

  /* ---- Hero load state (image scale-in + headline mask reveal) --------- */
  function initHero() {
    var hero = document.querySelector('[data-animate-hero]');
    if (!hero) return;
    requestAnimationFrame(function () {
      hero.classList.add('is-loaded');
    });

    var img = hero.querySelector('[data-parallax]');
    if (img && !reduceMotion) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var offset = Math.min(window.scrollY * 0.15, 80);
          img.style.transform = 'translateY(' + offset + 'px)';
          ticking = false;
        });
      }, { passive: true });
    }
  }

  /* ---- Sticky/transparent header ---------------------------------------- */
  function initHeader() {
    var header = document.querySelector('.site-header--transparent');
    if (!header) return;
    
    // Always start dark/transparent, become frosted glass on scroll
    var toggleSolid = function () {
      header.classList.toggle('is-solid', window.scrollY > 40);
    };
    toggleSolid();
    window.addEventListener('scroll', toggleSolid, { passive: true });
  }

  /* ---- Side menu (left drawer) -------------------------------------------- */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.getElementById('SideMenu');
    var closeBtns = menu ? menu.querySelectorAll('[data-menu-close]') : [];
    var overlay = menu ? menu.querySelector('.side-menu__overlay') : null;
    if (!toggle || !menu) return;

    function open() {
      menu.hidden = false;
      requestAnimationFrame(function () { menu.classList.add('is-open'); });
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('is-locked');
    }
    function close() {
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      window.setTimeout(function () { menu.hidden = true; }, 500);
      var otherOverlaysOpen = document.querySelector('.cart-drawer.is-open, .search-drawer.is-open, .collection-filters.is-open');
      if (!otherOverlaysOpen) document.body.classList.remove('is-locked');
    }

    toggle.addEventListener('click', function () {
      menu.classList.contains('is-open') ? close() : open();
    });
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    menu.querySelectorAll('.side-menu__nav a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) close(); });
  }

  /* ---- Custom cursor (desktop only) --------------------------------------- */
  function initCustomCursor() {
    // Custom cursor disabled - using native cursor for better UX
    return;
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBrandIntro();
    initReveal();
    initHero();
    initHeader();
    initMobileMenu();
    initCustomCursor();
  });
})();
